<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="70%"
    top="5vh"
    :before-close="handleClose"
    custom-class="terms-dialog"
  >
    <div class="pass-rule-box">
      <div class="rule-title">
        <h3>服务条款</h3>
        <el-button class="btn-close" @click="closeDialog" circle icon="el-icon-close"></el-button>
      </div>
      <div class="rule-nr">
        <p>一、定义</p>
        <p>平台，是指您当前所浏览的网站平台（HC社区商城）。</p>
        <p>
          用户，包含注册用户和非注册用户，以下亦称为"您"。注册用户是指通过我们平台完成全部注册程序后，使用我们平台服务或我们网站资料的用户。非注册用户是指未进行注册、直接登录我们平台或通过其他网站进入我们平台直接或间接地使用我们平台服务或我们网站资料的用户。
        </p>
        <p>协议方，本协议中协议双方合称"协议方"。</p>
        <p>二、协议的效力</p>
        <ol>
          <li>在您按照注册页面提示填写信息、阅读并同意本协议完成全部注册程序后，您即受本协议的约束。</li>
          <li>
            本协议内容包括本协议正文《隐私政策》，所有我们已经发布的或将来可能发布的规则为本协议不可分割的组成部分，与本协议具有同等法律效力。除另行明确声明外，任何我司网站提供的服务（以下称为"我们平台服务"）均受本协议约束。您承诺接受并遵守本协议的约定。如果您不同意本协议的约定，您应立即停止注册程序或停止使用我们平台服务；如您继续访问和使用我们平台服务，即视为您已确知并完全同意本协议各项内容。
          </li>
          <li>
            我们有权根据国家法律法规的更新、产品和服务规则的调整需要不时地制订、修改本协议或各类规则，并提前以网站公示的方式进行公示。如您继续使用我们平台服务的，即表示您接受经修订的协议和规则。如发生有关争议时，以我们最新的相关协议和规则为准。
          </li>
        </ol>
        <!-- 其他条款内容保持不变 -->
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'TermsDialog',
  data() {
    return {
      dialogVisible: false
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
    },
    handleClose(done) {
      done()
    }
  }
}
</script>

<style scoped>
.pass-rule-box {
  padding: 20px;
}
.rule-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.rule-title h3 {
  font-size: 18px;
  color: #333;
}
.btn-close {
  border: none;
  background: transparent;
  font-size: 18px;
  cursor: pointer;
}
.rule-nr {
  max-height: 60vh;
  overflow-y: auto;
  line-height: 1.6;
}
.rule-nr p, .rule-nr ol, .rule-nr ul {
  margin-bottom: 10px;
}
.rule-nr ol, .rule-nr ul {
  padding-left: 20px;
}
</style>